import { render, staticRenderFns } from "./LoanTierComponent.vue?vue&type=template&id=0b508756&"
import script from "./LoanTierComponent.vue?vue&type=script&lang=js&"
export * from "./LoanTierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports